import get from "lodash/get";

export default function(errors, csv) {
  if (csv === '') {
    return '';
  }
  const errMap = errors.reduce(function (map, obj) {
    const index = get(obj, 'meta.index');
    const detail = get(obj, 'detail');
    const key = parseInt(index, 10);
    if (map[key]) {
      map[key] += `;${detail}`;
    } else {
      map[key] = detail;
    }
    return map;
  }, {})

  return csv.split('\n').map(function (line, index) {
    if (index === 0) {
      return 'errors,'.concat(line);
    }
    if (errMap[index]) {
      return `${errMap[index]}, ${line}`
    }
    if (line === '') {
      return line
    }
    return `"",${line}`
  }).filter((val) => val !== '').join('\n');
}